import React from "react";
import {
  Button,
  Typography,
  Container,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  SearchOff as SearchOffIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";


export default function Page404() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  return (
    <Box 
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: { xs: 4, md: 8 }
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center' }}>
          {/* Icon */}
          <SearchOffIcon 
            sx={{ 
              fontSize: { xs: '4rem', md: '6rem' },
              color: 'error.main',
              mb: 3
            }} 
          />
          
          {/* Title */}
          <Typography 
            variant={isMobile ? "h3" : "h1"} 
            component="h1"
            gutterBottom
            sx={{ 
              color: 'text.primary',
              fontWeight: 600,
              mb: 2
            }}
          >
            404: Page Not Found
          </Typography>
          
          {/* Message */}
          <Typography 
            variant="h6" 
            color="text.secondary"
            sx={{ 
              mb: 4,
              maxWidth: 600,
              mx: 'auto',
              lineHeight: 1.6
            }}
          >
            Oops! The page you're looking for doesn't exist or has been moved.
          </Typography>
          
          {/* Button */}
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => navigate("/")}
            sx={{ 
              mt: 2,
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              borderRadius: 2
            }}
          >
            Return to Home
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
